import { useState } from "react";
import HeaderBar from "../HeaderBar";
import useStateMachineWrapper from "../../helpers/useStateMachineWrapper";

import ContentButton from "../ContentButton";
import { useForm } from "react-hook-form";
import { withHookFormMask } from "use-mask-input";
import sleep from "../../helpers/sleep";
import { dataLayerPush } from "../../helpers/analytics";
import MobileNextButton from "../MobileNextButton";

const ChoosePhone = (props) => {
  const {actions, state} = useStateMachineWrapper();

  const [isLoading, setIsLoading] = useState(false);


  const { control, register, handleSubmit, formState: { errors, isValid, submitCount } } = useForm({
    mode: 'onTouched',
    defaultValues: {
      existingNumber: state.session.existingNumber
    },
  });

  const phoneService = state.session.availableServices.phone[0];
  const phoneCost = phoneService.amount;// '9.99';
  const batteryCost = phoneService.battery_amount;// '2.99';

  const toggle = (type) => {
    let newVal = !state.session[type];

    actions.update({[type]: newVal});
  }

  const togglePhone = () => {
    if(!state.session.phone) {
      dataLayerPush({
        'event' : 'add_phone',
        'phone-total' : phoneCost
      });
    } else {
      dataLayerPush({
        'event' : 'remove_phone',
        'phone-total' : phoneCost
      });
    }

    toggle('phone');
  };
  const toggleBattery = () => {
    if(!state.session.battery) {
      dataLayerPush({
        'event' : 'add_battery',
        'batteryPrice' : batteryCost
      });
    } else {
      dataLayerPush({
        'event' : 'remove_battery',
        'batteryPrice' : 0,//batteryCost
      });
    }

    toggle('battery');
  };
  const togglePort = () => {
    toggle('portExistingNumber');
  };

  const updateData = (data) => {
    actions.update(data);
  }
  const manuallySubmit = async () => {
    setIsLoading(true);
    handleSubmit(updateData)();

    // handleSubmit isn't promise-based so we need to give a slight delay before proceeding otherwise our page might not update correctly
    await sleep(50);

    setIsLoading(false);

    return true;
  }

  const phoneBullets = [
    'Stay connected with the security of a landline phone',
    'Unlimited Long Distance',
    'Endless Local Calls Free calls to US, Canada, Guam and Puerto Rico',
    'Amazingly low rates to other international destinations',
    'Battery back-up recommended to keep your phone connected for up to 8 hours during a power outage',
  ];

  return (<>
        {/* <Breadcrumbs /> */}

        <HeaderBar backPage={'choose-wifi'} nextPage={'order-summary'} className="items-center" nextPageLoading={isLoading} nextPageEnabled={!state.session.phone || !state.session.portExistingNumber || isValid} nextPageAction={manuallySubmit}>
          <h1 className="bigger">Would you like to add a Home Phone?</h1>
        </HeaderBar>

        <div className="grid grid-flow-row-dense grid-cols-1 md:grid-cols-2 gap-4 my-4">
          <ContentButton className="md:col-span-2 flex flex-col gap-4 pb-4 items-center justify-between" isActive={state.session.phone} onClick={()=>togglePhone()}>
              <div>
                <p className="text-3xl font-black !leading-none">Add Phone</p>
              </div>

              <div>
                <p className="text-3xl font-bold !leading-none">${phoneCost}</p>
                <p className="!text-sm !leading-none font-bold">MONTH</p>
              </div>

          </ContentButton>
          {state.session.phone && (<>
            <ContentButton className="flex-1 flex flex-col gap-4 pb-4 items-center justify-between" isActive={state.session.battery} onClick={()=>toggleBattery()}>
              <div>
                <p className="text-2xl font-black !leading-none">Add Battery Backup?</p>
              </div>

              <div>
                <p className="text-3xl font-bold !leading-none">${batteryCost}</p>
                <p className="!text-sm !leading-none font-bold">MONTH</p>
              </div>
            </ContentButton>

            <ContentButton className="flex-1 flex flex-col gap-4 pb-4 items-center justify-center" isActive={state.session.portExistingNumber} onClick={()=>togglePort()}>
              <div>
                <p className="text-2xl font-black !leading-none">Keep My Number</p>
              </div>
            </ContentButton>

            {state.session.portExistingNumber && (
              <div className="md:col-span-2">
                <form className="w-full max-w-xl mx-auto mt-2">
                {/* <input className="w-full mx-auto" type="tel" placeholder="Existing Number" {...register("existingNumber", {required: true, maxLength: 12})} onChange={(e) => {actions.update({existingNumber: e.target.value})}} /> */}
                <input className="w-full mx-auto" type="text" placeholder="Existing Number" {...withHookFormMask(register("existingNumber", {required: 'Existing number is required'}), ['(999) 999-9999'])} />
                </form>
              </div>
            )}

          </>)}
        </div>

        <ul role="list" className="text-lg inline-block text-left marker:text-purple !list-disc !pl-5 !space-y-1">{phoneBullets.map((b,i) => <li key={i}>{b}</li>)}</ul>
        
        <HeaderBar backPage={'choose-wifi'} nextPage={'order-summary'} className="items-center" nextPageLoading={isLoading} nextPageEnabled={!state.session.phone || !state.session.portExistingNumber || isValid} nextPageAction={manuallySubmit}></HeaderBar>
    </>)

};

export default ChoosePhone;
